import type { ClientInput } from "@frontier/protocol/contracts";
import type { Point } from "./game/geometry";

/** Session teardown and suspended controls send the same complete wire intent. */
export function neutralFlightInput(position: Point = { x: 0, y: 0 }): Omit<ClientInput, "seq"> {
  return {
    mx: 0,
    my: 0,
    targetId: "",
    fire: false,
    boost: false,
    aimX: position.x,
    aimY: position.y,
  };
}
